<div class="cancellation-policy">
    <h1 class="title">Cancellation Policy</h1>

    <section class="policy-introduction">
        <p>At Sharani Ponguru, we are committed to delivering powerful transformational products and services with love, integrity, and excellence.</p>
        <p>We strive to ensure that every customer has a positive and fulfilling experience. In rare cases where you find the product or service unsatisfactory, please review the following policy regarding cancellation and refund eligibility:</p>
    </section>

    <section class="physical-products">
        <h2>For Book Orders (Physical Products):</h2>
        <ul>
            <li>If you receive a damaged or tampered package, kindly refuse delivery and inform us immediately at thesharaniponguru@gmail.com along with your Order Number and a clear photo of the damaged package.</li>
            <li>You must notify us within 72 hours of delivery to be eligible for a replacement.</li>
            <li>A replacement will be sent after validation, and shipping will be covered by us.</li>
            <li>Products bought at a discounted price or during special offers are not eligible for return/refund.</li>
        </ul>
    </section>

    <section class="digital-products">
        <h2>For Digital Products (Courses, Programs, Sessions):</h2>
        <ul>
            <li>Due to the nature of our digital offerings, cancellation and refunds will not be entertained once access has been granted (including video modules, session links, or bonus materials).</li>
            <li>For pre-ordered programs, cancellations can be requested before program access begins. Once the digital content is shared via WhatsApp/email, no cancellations will be accepted.</li>
            <li>In special circumstances, refunds for digital products may be approved if no access was made and the request is within 7 days of purchase.</li>
        </ul>
    </section>

    <section class="live-events">
        <h2>For Live Events or Coaching Sessions:</h2>
        <ul>
            <li>Cancellations for paid live events or sessions will be eligible for a full refund if requested within 7 days of purchase and before the event date.</li>
            <li>After this period, no refunds will be provided, though transfers to another participant may be permitted upon request.</li>
        </ul>
    </section>

    <section class="important-notes">
        <h2>Important Notes:</h2>
        <ul>
            <li>We are a digital ecosystem that delivers instant access to powerful learning and healing tools. We urge you to go through all product details before making a purchase.</li>
            <li>Please understand that refund or cancellation requests outside the specified windows will not be accepted.</li>
            <li>If eligible for a refund, the amount will be credited to your account within 7–8 business days, and will be processed only via net banking.</li>
            <li>For any queries, please contact us at +91 7337399049, +91 7892466625</li>
        </ul>
    </section>
</div>